export { genetecIntegration } from "./genetecIntegration";
